var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.supplier)?_c('router-link',{attrs:{"to":{name: 'Supplier', params: {id: _vm.supplier.id}}}},[_vm._v(" "+_vm._s(_vm.supplier.name)+" ")]):_c('span',[_vm._v(_vm._s(_vm.$t('common.misc.NA')))])
}
var staticRenderFns = []

export { render, staticRenderFns }